import { useId } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { adminGameFromLocation, getAdminGames } from '@/lib/admin-game-api';
import { useAuthStore } from '@/lib/auth-store';
import { useDirtyStore } from '@/lib/dirty-store';
import './admin-game-selector.css';

export function AdminGameSelector({ className = '', onNavigate }: { className?: string; onNavigate?: () => void }) {
  const id = useId();
  const location = useLocation();
  const navigate = useNavigate();
  const me = useAuthStore(s => s.me);
  const game = adminGameFromLocation(location.pathname, location.search);
  const games = useQuery({ queryKey: ['admin-game', 'ec1', 'catalog', me?.discordId], queryFn: ({ signal }) => getAdminGames(signal), retry: false });
  const available = games.data?.games.find(entry => entry.id === 'ec1')?.available;
  return <span className={`admin-game-selector ${className}`}><label className="sr-only" htmlFor={id}>Admin workspace</label>
    <select id={id} value={game} onChange={event => {
      if (!useDirtyStore.getState().confirmLeave()) return;
      navigate(event.target.value === 'ec1' ? '/games/ec1/players' : '/accounts');
      onNavigate?.();
    }}><option value="ec2">EC2 admin</option><option value="ec1">EC1 admin{available === false ? ' (unavailable)' : ''}</option></select>
  </span>;
}
